import { render } from "./Detail.vue?vue&type=template&id=28f01e2c&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"

import "./Detail.vue?vue&type=style&index=0&id=28f01e2c&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/prd-cce-chain-browser-static-nft/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28f01e2c"]])

export default __exports__